import { render, staticRenderFns } from "./SiteNavDesktopV2.vue?vue&type=template&id=d45d8408&scoped=true&lang=pug"
import script from "./SiteNavDesktopV2.vue?vue&type=script&lang=js"
export * from "./SiteNavDesktopV2.vue?vue&type=script&lang=js"
import style0 from "./SiteNavDesktopV2.vue?vue&type=style&index=0&id=d45d8408&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d45d8408",
  null
  
)

export default component.exports